<glxy-table-container
  [columns]="columns"
  [dataSource]="tableDataSource()"
  [pageSizeOptions]="[20, 50, 100]"
  [showSelection]="true"
  (selectionChanged)="selectionChanged($event)"
  [border]="false"
>
  <glxy-table-content-header
    [showFilters]="false"
    [showActions]="false"
    [showSort]="false"
    [showColumnArrange]="false"
    class="table-content-header"
  >
  </glxy-table-content-header>
  <table mat-table>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <glxy-table-selection />
      </th>
      <td mat-cell *matCellDef="let row">
        <glxy-table-selection [row]="row" [disableSelection]="isRowDisabled(row)" />
      </td>
    </ng-container>
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon class="capability-icon">bolt</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: []"></tr>
  </table>
</glxy-table-container>
